import { Schema, arrayOf, unionOf } from 'normalizr';

export const threadMessageSchema = new Schema('threadMessages');

export const threadSchema = new Schema('threads');

export const questionnaireSchema = new Schema('questionnaires');

export const questionSchema = new Schema('questions');

export const chatMessageSchema = new Schema('chatMessages');

export const chatQuestionnaireSchema = new Schema('chatQuestionnaires');

export const chatQuestionSchema = new Schema('chatQuestions');

export const chatResourceSchema = new Schema('chatResources', {
  idAttribute: entity => entity.sentAt + '_' + entity.data.url
});

export const magazineArticleSchema = new Schema('magazineArticles');

export const forumThreadSchema = new Schema('forumThreads');

export const commentSchema = new Schema('comments');

export const categorySchema = new Schema('categories');

export const topicSchema = new Schema('topics');

export const userAvatarSchema = new Schema('userAvatars');

export const goalSchema = new Schema('goals');

export const journalEntrySchema = new Schema('journalEntries');

export const searchResultSchema = unionOf({
  article: magazineArticleSchema,
  articles: commentSchema,
  articleComments: commentSchema,
  forumThread: forumThreadSchema,
  forumThreads: commentSchema,
  forumThreadComments: commentSchema
}, { schemaAttribute: 'resourceType' });

export const threadsArraySchema = arrayOf(threadSchema);

export const threadMessagesArraySchema = arrayOf(threadMessageSchema);

export const questionsArraySchema = arrayOf(questionSchema);

export const chatMessagesArraySchema = arrayOf(chatMessageSchema);

export const chatQuestionsArraySchema = arrayOf(chatQuestionSchema);

export const chatResourcesArraySchema = arrayOf(chatResourceSchema);

export const magazineArticlesArraySchema = arrayOf(magazineArticleSchema);

export const forumThreadsArraySchema = arrayOf(forumThreadSchema);

export const commentsArraySchema = arrayOf(commentSchema);

export const categoriesArraySchema = arrayOf(categorySchema);

export const topicsArraySchema = arrayOf(topicSchema);

export const userAvatarsArraySchema = arrayOf(userAvatarSchema);

export const goalsArraySchema = arrayOf(goalSchema);

export const journalEntriesArraySchema = arrayOf(journalEntrySchema);

export const searchResultsArraySchema = arrayOf(searchResultSchema);

threadSchema.define({
  latestMessage: threadMessageSchema
});

chatQuestionnaireSchema.define({
  questions: chatQuestionsArraySchema
});

questionnaireSchema.define({
  questions: questionsArraySchema
});




/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/schemas.js
 **/